import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';
import { CartItemsComponent } from '@theme/component-cart-items';

class CrCartStraps extends HTMLElement {
  static pending = false;

  connectedCallback() {
    this.controller = new AbortController();
    this.addEventListener('submit', this.addStraps, { signal: this.controller.signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  onCartUpdate = (event) => {
    const button = this.querySelector('button');
    button.disabled = true;
    event.promise?.finally(() => {
      if (this.isConnected && !CrCartStraps.pending && !this.completed) button.disabled = false;
    }).catch(() => {});
  };

  addStraps = async (event) => {
    event.preventDefault();
    if (CrCartStraps.pending) return;
    const form = this.querySelector('form');
    const button = this.querySelector('button');
    const status = this.querySelector('[role="status"]');
    const label = button.textContent;
    button.disabled = true;
    await Promise.allSettled(CartItemsComponent.pendingQuantityUpdates);
    if (!this.isConnected || CrCartStraps.pending) return;

    CrCartStraps.pending = true;
    button.textContent = this.dataset.adding;
    status.textContent = '';
    this.setAttribute('aria-busy', 'true');
    const id = form.elements.namedItem('id').value;
    const quantity = Number(form.elements.namedItem('quantity').value);
    const root = window.Shopify.routes.root;
    const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
      .map((component) => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'cart', lines: [{ merchandiseId: id, quantity }], promise: deferred.promise,
    }));
    let added = false;

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }], sections, sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
      added = true;
      this.completed = true;
      button.textContent = this.dataset.added;
      status.textContent = this.dataset.added;
      let cart = null;
      let items;
      try {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const ajaxCart = await cartResponse.json();
          cart = CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart);
          items = ajaxCart.items;
        }
      } catch {}
      deferred.resolve({ cart, detail: { items, sections: data.sections, source: 'cr-cart-straps', didError: false } });
    } catch (error) {
      status.textContent = error.message || this.dataset.error;
      deferred.reject(error);
    } finally {
      CrCartStraps.pending = false;
      this.removeAttribute('aria-busy');
      if (!added) {
        button.disabled = false;
        button.textContent = label;
      }
    }
  };
}

if (!customElements.get('cr-cart-straps')) customElements.define('cr-cart-straps', CrCartStraps);
